var render = function render(_c,_vm){return _c('div',{staticClass:"nav-title bold upper xs-f-medium lg-f-small max-at-tweak brand-color-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }